/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Event_Reminder_BodyInputs */

const th_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูกำหนดการเพื่อตรวจสอบเวลาเริ่มแข่ง`)
};

const en_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the schedule for tip-off times.`)
};

const ja_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合開始時刻はスケジュールで確認してください。`)
};

const zh_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛程中有开球时间。`)
};

const es_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta el calendario para ver las horas de inicio.`)
};

const pt_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja o calendário para os horários.`)
};

const id_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwal berisi waktu tip-off.`)
};

const fr_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultez le calendrier pour les horaires.`)
};

const tl_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasa iskedyul ang mga oras ng tip-off.`)
};

const vi_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch thi đấu có giờ bóng lên rổ.`)
};

const ko_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일정에 경기 시작 시각이 있습니다.`)
};

const de_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anwurfzeiten stehen im Spielplan.`)
};

const ru_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время начала матчей есть в расписании.`)
};

const tr_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlama saatleri fikstürde.`)
};

const it_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli orari di palla a due sono nel calendario.`)
};

const pl_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godziny rozpoczęcia są w terminarzu.`)
};

const uk_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Час початку матчів є в розкладі.`)
};

const hi_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू होने के समय कार्यक्रम में हैं।`)
};

const ar_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مواعيد البدء في الجدول.`)
};

const ms_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu mula ada dalam jadual.`)
};

const bn_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুরুর সময় সূচিতে আছে।`)
};

const zh_tw2_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽程中有開賽時間。`)
};

const zh_hk2_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽程中有開賽時間。`)
};

const ur_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شروع ہونے کے اوقات شیڈول میں ہیں۔`)
};

const fa_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زمان‌های شروع در برنامه آمده است.`)
};

const sw_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyakati za kuanza zipo kwenye ratiba.`)
};

const nl_push_event_reminder_body = /** @type {(inputs: Push_Event_Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De aanvangstijden staan in het schema.`)
};

/**
* | output |
* | --- |
* | "Check the schedule for tip-off times." |
*
* @param {Push_Event_Reminder_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_event_reminder_body = /** @type {((inputs?: Push_Event_Reminder_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Event_Reminder_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_event_reminder_body(inputs)
	if (locale === "ja") return ja_push_event_reminder_body(inputs)
	if (locale === "zh") return zh_push_event_reminder_body(inputs)
	if (locale === "es") return es_push_event_reminder_body(inputs)
	if (locale === "pt") return pt_push_event_reminder_body(inputs)
	if (locale === "id") return id_push_event_reminder_body(inputs)
	if (locale === "fr") return fr_push_event_reminder_body(inputs)
	if (locale === "tl") return tl_push_event_reminder_body(inputs)
	if (locale === "vi") return vi_push_event_reminder_body(inputs)
	if (locale === "ko") return ko_push_event_reminder_body(inputs)
	if (locale === "de") return de_push_event_reminder_body(inputs)
	if (locale === "ru") return ru_push_event_reminder_body(inputs)
	if (locale === "tr") return tr_push_event_reminder_body(inputs)
	if (locale === "it") return it_push_event_reminder_body(inputs)
	if (locale === "pl") return pl_push_event_reminder_body(inputs)
	if (locale === "uk") return uk_push_event_reminder_body(inputs)
	if (locale === "hi") return hi_push_event_reminder_body(inputs)
	if (locale === "ar") return ar_push_event_reminder_body(inputs)
	if (locale === "ms") return ms_push_event_reminder_body(inputs)
	if (locale === "bn") return bn_push_event_reminder_body(inputs)
	if (locale === "zh-TW") return zh_tw2_push_event_reminder_body(inputs)
	if (locale === "zh-HK") return zh_hk2_push_event_reminder_body(inputs)
	if (locale === "ur") return ur_push_event_reminder_body(inputs)
	if (locale === "fa") return fa_push_event_reminder_body(inputs)
	if (locale === "sw") return sw_push_event_reminder_body(inputs)
	if (locale === "nl") return nl_push_event_reminder_body(inputs)
	return en_push_event_reminder_body(inputs)
});